import { InputCheckboxComponent } from './input-checkbox.component';

export default angular
  .module('sfMobile.components.input-checkbox', [])
  .component('sfInputCheckbox', InputCheckboxComponent).name;
